import React from 'react'
import './NaoEncontrada.css'

function NaoEncontrada() {
  return (
    <main className="nao-encontrada">
      <h1>Página não encontrada</h1>
      <p className="nao-encontrada__simbolo">
        :-(
      </p>
    </main>
  )
}

export default NaoEncontrada;